import { render, staticRenderFns } from "./AdminOrganization.vue?vue&type=template&id=324f041f&scoped=true&"
import script from "./AdminOrganization.vue?vue&type=script&lang=js&"
export * from "./AdminOrganization.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrganization.vue?vue&type=style&index=0&id=324f041f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324f041f",
  null
  
)

export default component.exports